/**
 * Removes a specific parameter from search parameters
 * @param searchParams - Current URLSearchParams object
 * @param paramKey - The parameter key to remove
 * @returns Updated search params string without the specified parameter
 */
export const removeSearchParam = (searchParams: URLSearchParams, paramKey: string): string => {
  const updatedSearchParams = new URLSearchParams(searchParams);
  updatedSearchParams.delete(paramKey);
  return updatedSearchParams.toString();
};
